import { Button, Checkbox, Col, Form, Modal, Row, Spin, Input, InputNumber } from 'antd';
import { useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import BreadCrumbs from '../../../../common/components/Breadcrumbs';
import { validateMessages } from '../../../../common/constants/common';
import { Page } from '../../../../common/constants/pageAction';
import { getObjectForUpdateMultiple } from '../../../../common/helperFunction';
import { IConfigSoftwareMetric } from '../../../../services/master/configSoftwareMetric/configSoftwareMetric.model';
import { useAppSelector, useAppDispatch } from '../../../../store/app.hooks';
import { updateMultiple } from '../../../../store/common/common.action';
import {
  clearMultipleUpdateMessages,
  commonSelector,
} from '../../../../store/common/common.reducer';
import {
  getConfigSoftwareMetricById,
  saveConfigSoftwareMetric,
} from '../../../../store/master/configSoftwareMetric/configSoftwareMetric.action';
import {
  clearConfigSoftwareMetricGetById,
  clearConfigSoftwareMetricMessages,
  configSoftwareMetricSelector,
} from '../../../../store/master/configSoftwareMetric/configSoftwareMetric.reducer';
import { IAddConfigSoftwareMetricProps } from './addConfigSoftwareMetric.model';
import _ from 'lodash';

const AddConfigSoftwareMetricModal: React.FC<IAddConfigSoftwareMetricProps> = (props) => {
  const configSoftwareMetric = useAppSelector(configSoftwareMetricSelector);
  const common = useAppSelector(commonSelector);
  const dispatch = useAppDispatch();
  const { id, showModal, handleModalClose, refreshDataTable, isMultiple, valuesForSelection } =
    props;

  const isNew: boolean = id || isMultiple ? false : true;
  const title = useMemo(() => {
    return (
      <>
        {isNew ? 'Add ' : 'Edit '} <BreadCrumbs pageName={Page.ConfigSoftwareMetric} level={1} />
      </>
    );
  }, [isNew]);
  const submitButtonText = useMemo(() => {
    return isNew ? 'Save' : 'Update';
  }, [isNew]);

  const [form] = Form.useForm();

  let initialValues: IConfigSoftwareMetric = {
    metric: '',
    metric_index: null,
  };

  const onFinish = (values: any) => {
    const inputValues: IConfigSoftwareMetric = {
      ...values,
      id: id ? +id : null,
    };
    if (!isMultiple) {
      dispatch(saveConfigSoftwareMetric(inputValues));
    } else {
      const result = getObjectForUpdateMultiple(
        valuesForSelection,
        inputValues,
        configSoftwareMetric.search.tableName
      );
      if (result) {
        dispatch(updateMultiple(result));
      }
    }
  };

  const fillValuesOnEdit = async (data: IConfigSoftwareMetric) => {
    if (data) {
      initialValues = {
        metric: data.metric,
        metric_index: _.isNull(data.metric_index) ? null : data.metric_index,
      };
      form.setFieldsValue(initialValues);
    }
  };

  useEffect(() => {
    if (configSoftwareMetric.save.messages.length > 0) {
      if (configSoftwareMetric.save.hasErrors) {
        toast.error(configSoftwareMetric.save.messages.join(' '));
      } else {
        toast.success(configSoftwareMetric.save.messages.join(' '));
        handleModalClose();
        refreshDataTable();
      }
      dispatch(clearConfigSoftwareMetricMessages());
    }
  }, [configSoftwareMetric.save.messages]);

  useEffect(() => {
    if (common.save.messages.length > 0) {
      if (common.save.hasErrors) {
        toast.error(common.save.messages.join(' '));
      } else {
        toast.warn(common.save.messages.join(' '));
        handleModalClose();
        refreshDataTable();
      }
      dispatch(clearMultipleUpdateMessages());
    }
  }, [common.save.messages]);

  useEffect(() => {
    if (+id > 0 && configSoftwareMetric.getById.data) {
      const data = configSoftwareMetric.getById.data;
      fillValuesOnEdit(data);
    }
  }, [configSoftwareMetric.getById.data]);

  useEffect(() => {
    if (+id > 0) {
      dispatch(getConfigSoftwareMetricById(+id));
    }
    return () => {
      dispatch(clearConfigSoftwareMetricGetById());
    };
  }, [dispatch]);

  return (
    <>
      <Modal
        wrapClassName="custom-modal"
        title={title}
        centered
        visible={showModal}
        onCancel={handleModalClose}
        footer={false}
      >
        {configSoftwareMetric.getById.loading ? (
          <div className="spin-loader">
            <Spin spinning={configSoftwareMetric.getById.loading} />
          </div>
        ) : (
          <Form
            form={form}
            name="configSoftwareMetric"
            initialValues={initialValues}
            onFinish={onFinish}
            validateMessages={validateMessages}
          >
            <Row gutter={[30, 15]} className="form-label-hide">
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'metric']} valuePropName="checked" noStyle>
                      <Checkbox>Metric</Checkbox>
                    </Form.Item>
                  ) : (
                    'Metric'
                  )}
                  <Form.Item
                    name="metric"
                    label="Metric"
                    className="m-0"
                    rules={[{ required: !isMultiple, max: 255 }]}
                  >
                    <Input className="form-control" />
                  </Form.Item>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'metric_index']} valuePropName="checked" noStyle>
                      <Checkbox>Metric Index</Checkbox>
                    </Form.Item>
                  ) : (
                    'Metric Index'
                  )}
                  <Form.Item
                    name="metric_index"
                    label="Metric Index"
                    className="m-0"
                    rules={[{ type: 'integer' }]}
                  >
                    <InputNumber className="form-control w-100" />
                  </Form.Item>
                </div>
              </Col>
            </Row>
            <div className="btns-block modal-footer">
              <Button
                key="submit"
                type="primary"
                htmlType="submit"
                loading={configSoftwareMetric.save.loading || common.save.loading}
              >
                {submitButtonText}
              </Button>
              <Button key="back" onClick={handleModalClose}>
                Cancel
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    </>
  );
};
export default AddConfigSoftwareMetricModal;
